export default "__VITE_ASSET__cMKBRhcZ__"